import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconTrashColored: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9059 4.36947C17.2301 4.36947 17.5 4.63863 17.5 4.98113V5.29779C17.5 5.63195 17.2301 5.90945 16.9059 5.90945H3.09488C2.76988 5.90945 2.5 5.63195 2.5 5.29779V4.98113C2.5 4.63863 2.76988 4.36947 3.09488 4.36947H5.52464C6.01821 4.36947 6.44775 4.01864 6.55879 3.52364L6.68603 2.95531C6.88378 2.18115 7.53458 1.66699 8.27939 1.66699H11.7206C12.4573 1.66699 13.1154 2.18115 13.3059 2.91448L13.442 3.52281C13.5522 4.01864 13.9818 4.36947 14.4762 4.36947H16.9059ZM15.6715 15.9453C15.9252 13.5812 16.3693 7.9646 16.3693 7.90793C16.3855 7.73626 16.3296 7.57377 16.2186 7.44293C16.0994 7.32044 15.9487 7.24794 15.7826 7.24794H4.22377C4.05681 7.24794 3.89796 7.32044 3.78774 7.44293C3.6759 7.57377 3.62079 7.73626 3.62889 7.90793C3.63038 7.91834 3.64632 8.11618 3.67296 8.44694C3.79132 9.91631 4.12097 14.0088 4.33399 15.9453C4.48474 17.372 5.42082 18.2687 6.77672 18.3012C7.82302 18.3253 8.90094 18.3337 10.0032 18.3337C11.0414 18.3337 12.0958 18.3253 13.1745 18.3012C14.5774 18.277 15.5127 17.3962 15.6715 15.9453Z"
        fill={props.fill}
      />
    </Icon>
  );
};

export default IconTrashColored;
